module.exports = __webpack_public_path__ + "static/media/16UNODC40.6b5ef02e.jpg";